// @flow
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from '../../with-router'
import routerFunction from 'client/route.js'

import AuthService from 'client/utils/auth-service'
import validateEmail from 'client/utils/validate-email'

// $FlowFixMe
export class DefaultForm extends Component {
  props: {
    auth: AuthService,
    router: Object,
    connection: {
      name: string
    }
  }

  state: {
    email: string,
    password: string,
    submitted: boolean,
    showPassword: boolean,
    errors: Object
  }

  static displayName: string = 'Default Form'
  // $FlowFixMe
  state: any = {
    email: '',
    password: '',
    submitted: false,
    showPassword: false,
    errors: {}
  }
  // $FlowFixMe
  componentDidMount () {
    window.addEventListener('pageshow', this.onPageShow)
  }
  // $FlowFixMe
  componentWillUnmount () {
    window.removeEventListener('pageshow', this.onPageShow)
  }
  // Reset the pending/disabled state when the page is restored from the
  // bfcache (e.g. navigating back from the Select Organization page).
  // $FlowFixMe
  onPageShow: ((event: any) => void) = (event: any) => {
    if (event.persisted) {
      // $FlowFixMe
      this.setState({ submitted: false })
    }
  }
  // $FlowFixMe
  validate: (() => Object) = () => {
    const { email, password } = this.state
    const errors = {}
    if (!email || !email.trim()) {
      errors.email = 'Email is required'
    } else if (!validateEmail(email.trim())) {
      errors.email = 'Please enter a valid email address'
    }
    if (!password) {
      errors.password = 'Password is required'
    }
    return errors
  }
  // $FlowFixMe
  onSubmit: ((event: any) => Promise<void>) = async (event: SyntheticEvent) => {
    event.preventDefault()
    const { auth, connection } = this.props
    const router = routerFunction()
    const { email, password } = this.state

    const errors = this.validate()
    if (Object.keys(errors).length > 0) {
      // $FlowFixMe
      this.setState({ errors })
      return
    }
    // $FlowFixMe
    this.setState({ submitted: true, errors: {} })

    try {
      auth && await auth.loginWithCredentials({
        connection: connection.name,
        email,
        password,
        responseType: 'code'
      })
    } catch (e) {
      router.navigate('/incorrect-password')
    }
  }
  // $FlowFixMe
  onInput: ((any) => void) = ({ target: { value, name } }: SyntheticInputEvent) => {
    // $FlowFixMe
    this.setState((prev) => ({ [name]: value, errors: { ...prev.errors, [name]: undefined } }))
  }
  // $FlowFixMe
  togglePassword: (() => void) = () => {
    // $FlowFixMe
    this.setState((prev) => ({ showPassword: !prev.showPassword }))
  }

  render (): any {
    const { submitted, showPassword, errors } = this.state
    const submit = submitted ? 'Logging in...' : 'Sign In'
    return (
      <form className='login__form' disabled={submitted} onSubmit={this.onSubmit} noValidate>
        <div className='field'>
          <label className='field__label' htmlFor='email'>Email</label>
          <input
            id='email'
            className='field__input'
            type='email'
            placeholder='Email'
            disabled={submitted}
            name='email'
            onInput={this.onInput}
          />
          {errors.email && <span className='field__error'>{errors.email}</span>}
        </div>

        <div className='field'>
          <div className='field__label-row'>
            <label className='field__label' htmlFor='password'>Password</label>
            <Link to='forgot-password' className='login__forgot-password'>Forgot password?</Link>
          </div>
          <div className='field__password'>
            <input
              id='password'
              className='field__input'
              type={showPassword ? 'text' : 'password'}
              placeholder='Password'
              disabled={submitted}
              name='password'
              onInput={this.onInput}
            />
            <button
              type='button'
              className='field__eye'
              onClick={this.togglePassword}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? (
                <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' />
                  <circle cx='12' cy='12' r='3' />
                </svg>
              ) : (
                <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <path d='M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24' />
                  <line x1='1' y1='1' x2='23' y2='23' />
                </svg>
              )}
            </button>
          </div>
          {errors.password && <span className='field__error'>{errors.password}</span>}
        </div>

        <button className='login__button' type='submit' disabled={submitted}>{submit}</button>
      </form>
    )
  }
}

export default (withRouter(DefaultForm): any)
